module.exports = __webpack_public_path__ + "img/grayCoin.490c00c6.png";